/**
 * 平台判断，主要是根据 userAgent
 * @filename: packages/web-utils/src/Platform.ts
 * @author: Mr Prince
 * @date: 2022-02-28 13:52:57
 */
class Platform {
    /**
     * 是否是安卓
     */
    static isAndroid() {
        return !!navigator.userAgent.match(/Android/i);
    }
    /**
     * 是否是黑莓
     */
    static isBlackBerry() {
        return !!navigator.userAgent.match(/BlackBerry/i);
    }
    /**
     * 是否是ios
     */
    static isIOS() {
        return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
    }
    /**
     * 是否是windows
     */
    static isWindows() {
        return !!navigator.userAgent.match(/IEMobile/i);
    }
    /**
     * 是否是微信
     */
    static isWechat() {
        return !!navigator.userAgent.match(/MicroMessenger/i);
    }
    /**
     * 是否是pc
     */
    static isPC() {
        return !navigator.userAgent.match(/iPhone|Android|SymbianOS|Windows Phone|iPad|iPod/i);
    }
}
export default Platform;
//# sourceMappingURL=data:application/json;base64,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